import { Screen } from '~/screens/InternalNews';

export const InternalNews: React.FC = () => {
  return <Screen />;
};
